/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

 // Add global to window, assigning the value of window itself.
 (window as any).global = window;
 import "global-shim";

// This file includes polyfills needed by Angular 2 and is loaded before
// the app. You can add your own extra polyfills to this file.
import 'core-js'
import 'core-js/es6';
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/typed';
import 'core-js/es6/reflect';
import 'core-js/es7/reflect';
import 'core-js/es7/array';
import 'core-js/client/shim';
import 'intl';
import './polyfills/flexibility.js';
import './polyfills/classList.min.js';
import 'zone.js/dist/zone';

//Intl
import 'intl';
import 'intl/locale-data/jsonp/en.js';

// import 'classlist-polyfill';

// IE11 fix
// Ref: https://github.com/swimlane/ngx-charts/issues/386
if (typeof(SVGElement) !== "undefined" && typeof SVGElement.prototype.contains === 'undefined') {
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}
